function base64UrlEncode(arr: Uint8Array): string {
const str = btoa(String.fromCharCode(...arr));
  return str.replaceAll('=', '').replaceAll('+', '-').replaceAll('/', '_');
}

async function createCodeVerifier(len = 64): Promise<string> {
  const bytes = new Uint8Array(len);
  crypto.getRandomValues(bytes);
  return base64UrlEncode(bytes);
}

async function createCodeChallenge(verifier: string): Promise<string> {
  const data = new TextEncoder().encode(verifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return base64UrlEncode(new Uint8Array(digest));
}

let codeVerifier = '';
let codeChallenge = '';
let initPromise: Promise<void> | null = null;

async function initializePKCE(): Promise<void> {
  try {
    const storedVerifier = sessionStorage.getItem('code_verifier');
    if (storedVerifier) {
      codeVerifier = storedVerifier;
      codeChallenge = await createCodeChallenge(codeVerifier);
    } else {
      codeVerifier = await createCodeVerifier();
      codeChallenge = await createCodeChallenge(codeVerifier);
      sessionStorage.setItem('code_verifier', codeVerifier);
    }
  } catch (error) {
    console.trace('[PKCE] Error initializing PKCE:', error);
    throw error;
  }
}


initPromise = initializePKCE();

export const logindetails = {
  async ensureInitialized(): Promise<void> {
    if (initPromise !== null) {
      await initPromise;
  }
  },
  get codeVerifier(): string {
    return codeVerifier;
  },
  get codeChallenge(): string {
    return codeChallenge;
  }
};
